import React from 'react';
import clsx from 'clsx';

const iconsMap: { [x in IconType]: string } = {
  horn: 'fas fa-bullhorn',
  list: 'fas fa-tasks',
  rocket: 'fas fa-rocket',
  eye: 'fas fa-eye',
  people: 'fas fa-users',
  messages: 'fas fa-comments',
  hook: 'fas fa-bolt',
  document: 'fas fa-file-alt',
  chart: 'fas fa-chart-bar',
  refresh: 'fas fa-sync',
  edit: 'fas fa-edit',
  delete: 'fas fa-trash',
  plus: 'fas fa-plus',
  question: 'fas fa-question',
  play: 'fas fa-play',
  broom: 'fas fa-broom',
  loading: 'fas fa-spinner animate-spin',
  link: 'fas fa-link',
  send: 'fas fa-paper-plane',
  required: 'fas fa-asterisk',
  copy: 'fas fa-copy',
};

const iconsStylesMap: { [x in IconStyle]: string } = {
  default: '',
  danger: 'text-[#ef4444]',
};

type IconStyle = 'default' | 'danger';

type IconProps = {
  className?: string;
  icon?: IconType;
  width?: boolean;
  tooltip?: string;

  iconStyle?: IconStyle;
};

const Icon: React.FC<IconProps> = ({
  className,
  icon,
  tooltip,
  iconStyle = 'default',
  width = false,
}) => {
  if (!icon) return null;

  return (
    <i
      title={tooltip}
      className={clsx(
        className,
        iconsMap[icon],
        iconsStylesMap[iconStyle] || iconStyle,
        width && 'w-[2rem]'
      )}
    />
  );
};

export default React.memo(Icon) as typeof Icon;
